import { resolveAccess } from './resolveAccess'
import { useAccessSources } from './useAccessSources'
import type { AuthorizationRule, NonRecordAccessRule, RecordAccessRule } from './accessRules'
import type { AskedRecord } from './useRecordAuthorization'
import type { PermissionSetEntity } from '@omnea-app/authz'

const askedFor = (
  authorization: AuthorizationRule,
  recordId: string | undefined
): AskedRecord<PermissionSetEntity> | undefined =>
  authorization.kind === 'record' && recordId != null ? { entity: authorization.entity, recordId } : undefined

/**
 * Whether one rule admits the current caller, where withheld answers read as no. A surface that must
 * say something distinct while a check is in flight reads `useAccessSources` and calls `resolveAccess`
 * for the four-state answer instead.
 *
 * The overloads pair a record rule with the id it is asked about, so a rule naming a verb cannot reach
 * the evaluator without the record it names.
 */
export function useIsPermitted(rule: NonRecordAccessRule): boolean
export function useIsPermitted(rule: RecordAccessRule, recordId: string): boolean
export function useIsPermitted(rule: NonRecordAccessRule | RecordAccessRule, recordId?: string): boolean {
  const sources = useAccessSources(askedFor(rule.authorization, recordId))

  return resolveAccess(rule, sources) === 'allowed'
}
